import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { candidateExplainerData as data } from "../data/candidate-explainer.data";
import { useRedirectUrl } from "../hooks/useRedirectUrl";
import styles from "./candidate-explainer.module.scss";
import "./candidate-explainer.scss";

export function SiSupportAbout() {
  const redirect = useRedirectUrl("/second-interview-support");

  return (
    <div className={`${styles["candidateExplainer"]} candidate-container`}>
      <Helmet>
        <title>Sapia | Candidate Explainer</title>
        <meta http-equiv="refresh" content="0; url=https://sapia.ai/second-interview-support/about-sapia-video-interviews/" />
      </Helmet>

      {/* <div className={styles["explainerBanner"]}>
        <ul className={styles["landingBreadcrumbs"]}>
          {data?.header_section?.breadcrums.map((b, i) => {
            switch (i) {
              case 0:
                return (
                  <li className={styles["candidateBtn"]} key={i}>
                    <a href={redirect}>{b.label}</a>
                  </li>
                );
              default:
                return b.link ? (
                  <li key={i}>
                    <Link to={b.link}>{b.label}</Link>
                  </li>
                ) : (
                  <span>{b.label}</span>
                );
            }
          })}
        </ul>

        <div className={styles["tableOfContent"]}>
          <h3>About Sapia video interviews</h3>
          <ul>
            <li>
              <a href="#1">How do I access the test?</a>
            </li>
            <li>
              <a href="#2">Do I need to download anything in order to take this interview?</a>
            </li>
            <li>
              <a href="#3">What type of interview questions can I expect?</a>
            </li>
            <li>
              <a href="#4">Tips for completing your video interview</a>
            </li>
            <li>
              <a href="#5">What is the dress code for an online interview?</a>
            </li>
            <li>
              <a href="#6">Is this a replacement for a face to face interview?</a>
            </li>
            <li> 
              <a href="#7">I do not have a webcam</a>
            </li>
          </ul>
        </div>

        <div className={styles["siQA"]}>
          <div className={styles["siQAItem"]} id="1">
            <h4>How do I access the test?</h4>
            <p>You’ll be sent a link to begin the interview to your email address. This will come from notifications@predictivehire.com. Simply click on the link in the email to begin your video interview. </p>
          </div>

          <div className={styles["siQAItem"]} id="2">
            <h4>Do I need to download anything in order to take this interview?</h4>
            <p>No. The interview will be recorded from within the internet browser you’re using, so there is no need to download or install any additional software.</p>
          </div>

          <div className={styles["siQAItem"]} id="3">
            <h4>What type of interview questions can I expect?</h4>
            <p>You’ll be asked behaviour-based interview questions. These are questions that ask you to give specific examples of where you have completed a similar task in the past, for example, “Can you tell me about a time when you delivered excellent customer service”.</p>
          </div>

          <div className={styles["siQAItem"]} id="4">
            <h4>Tips for completing your video interview</h4>
            <p>Set yourself up somewhere quiet with a neutral background. Check the lighting to make sure you can be seen clearly and that the lighting doesn’t change with small movements, which may happen if you are sitting in front of a window. If you’re using your mobile phone make sure you pause any notifications and put it on silent. We recommend you use the test question to check that your recording is clear and audible.</p>
          </div>

          <div className={styles["siQAItem"]} id="5">
            <h4>What is the dress code for an online interview?</h4>
            <p>There is no formal dress code, but it’s important to treat this the same as you would any interview. Tidy, clean clothes are best, and hats or beanies should be removed.</p>
          </div>

          <div className={styles["siQAItem"]} id="6">
            <h4>Is this a replacement for a face to face interview?</h4>
            <p>More often than not there will still be an in-person interview, but this will be limited to a shortlist of suitable applicants. Make sure you treat this video interview the same as an in-person interview for your best chance at progressing to the next stage of the recruitment process.</p>
          </div>

          <div className={styles["siQAItem"]} id="7">
            <h4>I do not have a webcam</h4>
            <p>If you don’t have a webcam set up on your laptop or desktop computer you can complete your SecondInterview on either a mobile phone or tablet.</p>
          </div>
        </div>
      </div>

      <div className="interview-support-section explainer-padding">
        <div className="container">
          <div className="text-center">
            <h3 className="blue-title">{data.contact_section.section_title}</h3>
            <button
              type="button"
              className="btn-help"
              style={{ cursor: "pointer" }}
            >
              {data.contact_section.button_label}
            </button>
            <p>
              <a
                href={data.contact_section.privacy_button_link}
                className="black-link"
              >
                {data.contact_section.privacy_button_label}
              </a>
            </p>
            <p>
              <a href="/terms-of-service" className="black-link">
                Read our Terms of Service here {">"}
              </a>
            </p>
          </div>
        </div>
      </div> */}
    </div>
  );
}
